module.exports = __webpack_public_path__ + "img/klingon.332a5fc1.svg";